import { z } from "zod";

export const WEB_PUSH_INSTALL_INTENT_EVENT = "garimpa:web-push-install-intent";
export const WEB_PUSH_INSTALL_INTENT_STORAGE_KEY = "garimpa.webPush.installIntent.v1";
export const WEB_PUSH_INSTALL_INTENT_TTL_MS = 7 * 24 * 60 * 60 * 1000;

export const webPushInstallIntentSchema = z.object({
  requestedAt: z.number().int().nonnegative(),
});

export type WebPushInstallIntent = z.infer<typeof webPushInstallIntentSchema>;
